module.exports = "/images/login-btn-bg.png?203651abe71503228f2f2952c839a834";